import React, { useEffect, useState } from "react";
import CancelButton from "./cancel-button";
import Button from "./button";
import { fetchData } from "@/types/collection";
import { linkify } from "@/components/utils/linkify";
import { ItemFileData } from "@/types/collection";
import { videoPack } from "../utils/videoPack";
import LoadingStatus from "./loading-status";
import { getFileStorageUrlSync } from "@/utils/storage";

interface ConfirmModalProps {
  onClose: () => void;
  onApply?: () => void;
  item: ItemFileData;
  title: string;
}

export const ConfirmModal = ({
  onClose,
  onApply,
  item,
  title,
}: ConfirmModalProps) => {
  const [isIOS, setIsIOS] = useState<boolean>(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState<boolean>(false);

  return (
    <div className="flex flex-col h-screen">
      <div className="max-w-[430px] fixed top-0 flex justify-between items-center p-[10px]  bg-[#0099FE] w-full">
        <span className="text-[24px]">CONFIRM</span>
        <CancelButton onClick={onClose} />
      </div>
      <div className="flex flex-col w-full h-full overflow-y-auto mt-[60px] text-[33px] text-white">
        <span className="text-[26px] p-[20px] text-white">{item.name}</span>
        {!item.content_type?.startsWith("video") && (
          <img
            src={getFileStorageUrlSync(item.image)}
            alt="nft-image"
            className="max-w-[430px] max-h-[430px] object-contain"
          />
        )}
        {item.content_type?.startsWith("video") &&
          videoPack(isIOS, item.image, setIsVideoLoaded)}
        <div className="flex flex-col w-full text-[15px] p-[20px] text-white">
          <p className="whitespace-pre-wrap">
            {item.description ? linkify(item.description) : ""}
          </p>
          <div className="py-[20px]">
            {item.attributes?.map((item, index) => (
              <div
                key={`metadata-${index}`}
                className="border-b-2 border-[#757575] border-solid flex justify-between pt-[5px]"
              >
                <p className="w-[50%] text-[13px] text-[#757575] font-spline-sans-mono">
                  {item.trait_type}
                </p>
                <p className="w-[50%] text-[13px] text-[#757575] font-spline-sans-mono">
                  {item.value}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center items-center pb-[50px]">
          <Button
            className=" custom-aspect-320-63 text-[24px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
            image="/assets/button.svg"
            text="APPLY"
            onClick={onApply}
          />
        </div>
      </div>
    </div>
  );
};